import React, { FC } from "react";

const WebGlUnavailable: FC = () => (
  <div className="webgl-unavailable" role="alert">
    <p>
      Impossible de tracer le graphique sur votre navigateur, WebGL est indisponible ou désactivé.
      <br />
      Activez WebGL ou utilisez un autre navigateur.
    </p>
  </div>
);

export default WebGlUnavailable;
